<template>
    <div>
        <div class="row">
            <div class="col">
                <details-block :title="'P11D price'" :text="vehicle.meta.p11d" :currency="true"></details-block>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-md-4">
                <details-block :title="'Fuel type'" :text="fuel" :currency="false"></details-block>
            </div>
            <div class="col-6 col-md-4">
                <details-block :title="'Transmission'" :text="vehicle.transmission.name" :currency="false"></details-block>
            </div>
            <div class="col-6 col-md-4">
                <details-block :title="'Body style'" :text="vehicle.model.body.name" :currency="false"></details-block>
            </div>
            <div class="col-6 col-md-4">
                <details-block :title="'CO2 emissions (g/km)'" :text="vehicle.meta.co2" :currency="false"></details-block>
            </div>
            <div class="col-6 col-md-4">
                <details-block :title="'Combined MPG'" :text="vehicle.meta.mpg" :currency="false"></details-block>
            </div>
            <div class="col-6 col-md-4">
                <details-block :title="'Engine size (cc)'" :text="vehicle.meta.engineSize | numberFormat" :currency="false"></details-block>
            </div>
        </div>
    </div>
</template>

<script>
    import DetailsBlock from "./DetailsBlock";
    export default {
        name: "VehicleDetails",
        components: {DetailsBlock},
        computed: {
            vehicle: function() {
                return this.$store.state.VEHICLE;
            },
            fuel(){
                return this.vehicle.meta.fuelType.replace(/(CAR|LCV)/gi, '');
            }
        }
    }

</script>

<style scoped>

</style>